module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-01.d67bf142724462b286fe07ff9241370c.png";